const product_carousel_v2 = {
  content_placeholder: '[PRODUCT_CONTENT]',
  html_grid: `<div class="row">
    [PRODUCT_CONTENT]
  </div>`,
  html_swiper: `<div class="swiper">
    <div class="swiper-wrapper">[PRODUCT_CONTENT]</div>
    <div class="swiper-pagination"></div>
    <div class="swiper-button swiper-button-prev"></div>
    <div class="swiper-button swiper-button-next"></div>
    <div class="swiper-scrollbar"></div>
  </div>`,

  init: () => {
    const carousels = $('.product-carousel-v2');

    carousels.each(function(i) {
      var _this = $(this);
      var divs = $('> div', _this),
          divs_length = divs.length,
          
          cta_text = _this.data('cta_text') || '',
          explore_text = _this.data('explore_text') || '',
          view = _this.data('view') || 'api-html-carousel-v2',
          type = _this.data('type') || 'slider',
          
          slider_classname = `product-carousel-v2-${i}`;

      _this.addClass(slider_classname);

      $.each(divs, function(i, div) {
        var _this2 = $(this);
        var handle = _this2.data('product'),
            name = _this2.data('name') || '',
            image = _this2.data('image') || '',
            label = _this2.data('label') || '',
            variants = _this2.data('variants') || '',
            preselect = _this2.data('preselect') || '',
            _cta = typeof _this2.data('cta_enable') !== 'undefined' ? _this2.data('cta_enable') : true,
            _cta_text = _this2.data('cta_text') || cta_text,
            _explore = typeof _this2.data('explore_enable') !== 'undefined' ? _this2.data('explore_enable') : false,
            _explore_text = _this2.data('explore_text') || explore_text,
            _explore_link = _this2.data('explore_link') || '';
        $.get(`${Shopify.routes.root}products/${handle}?view=${view}`, function(product_html) {
          if (product_html.indexOf('<html') >= 0) {
            _this2.remove();
            return;
          }
          
          var string_id = Math.random().toString(36).substring(2,7);
          product_html = product_html.replaceAll('[string_id]', string_id);
          _this2.html(product_html);
          if (type == 'slider') _this2.addClass('swiper-slide');

          if (variants != '') {
            variants = variants.split(',');
            var option_ids = [],
                option_skus = [];
            $('.product-carousel-v2-img img', _this2).each(function() {
              var option_id = $(this).attr('data-variant_id'),
                  option_sku = $(this).attr('data-variant_sku');
              if (variants.indexOf(option_id) >= 0 || variants.indexOf(option_sku) >= 0) {
              } else {
                option_ids.push(option_id);
                option_skus.push(option_sku);
              }
            });
            if (view != 'api-html-carousel-v4') {
              $.each(option_ids, function(i, variant) {
                $(`.product-carousel-v2-img img[data-variant_id="${variant}"]`, _this2).remove();
              });
              $.each(option_skus, function(i, variant) {
                $(`.product-carousel-v2-img img[data-variant_sku="${variant}"]`, _this2).remove();
              });
            }
          }
          var first_img = $('.product-carousel-v2-img img:first-child', _this2);
          if (image != '') {
            first_img.attr('src', image);
          }
          first_img.addClass('active').siblings().removeClass('active');

          if (preselect != '') {
            $(`.product-carousel-v2-variants .swatch-element[data-sku="${preselect}"] input`, _this).attr('checked', true);
          } else {
            $('.product-carousel-v2-variants .swatch-element:first-child input', _this).attr('checked', true);
          }

          if (name != '') {
            if ($('.product-carousel-v2-title a', _this2).length == 1) $('.product-carousel-v2-title a', _this2).text(name);
            else $('.product-carousel-v2-title', _this2).text(name);
          }

          if (label != '' && $('.product-carousel-v2-label', _this2).length == 0) $('.product-carousel-v2-labels', _this2).html(`<div class="product-carousel-v2-label">${label}</div>`);
          
          if (_cta) {
            if (_cta_text != '') $('.product-carousel-v2-cta .btn-shop', _this2).text(_cta_text);
          } else {
            $('.product-carousel-v2-cta .btn-shop', _this2).parent().remove();
          }
          
          if (_explore) {
            if (_explore_text != '') $('.product-carousel-v2-cta .btn-explore', _this2).text(_explore_text).show();
            if (_explore_link != '') $('.product-carousel-v2-cta .btn-explore', _this2).attr('href', _explore_link);
          } else {
            $('.product-carousel-v2-cta .btn-explore', _this2).parent().remove();
          }

        }).fail(function() {
          _this2.remove();
        }).always(function() {
          divs_length--;

          if (divs_length == 0) {
            if (view == 'api-html-carousel-v4') {
              product_carousel_v2.v4.init(_this, slider_classname);
            } else {
              product_carousel_v2.setCarousel(_this, slider_classname);
            }
          }
        });
      });

      // fix swiper overflow:visible
      $(this).parents('div[data-gjs-component="section"]').last().wrap(`<div class="product-carousel-v2-section" style="overflow: hidden;" />`);
    });

    // var ivt = setInterval(function() {
    //   if (typeof Swiper === 'function') {
    //     clearInterval(ivt);
    //     $(document).trigger({
    //       type: 'init_product_carousel_v2'
    //     });
    //   }
    // }, 500);
    setTimeout(function() {
      $(document).trigger({
        type: 'init_product_carousel_v2'
      });
    }, 1000);
  },
  setCarousel: (_this, slider_classname) => {
    _this.html(product_carousel_v2.html_swiper.replace(product_carousel_v2.content_placeholder, _this.html()));

    var ivt = setInterval(function() {
      if (typeof Swiper === 'function') {
        clearInterval(ivt);
        product_carousel_v2.initSwiper(_this, `.${slider_classname}`);
      }

      if (window.location.pathname.indexOf('/collections/wireless-hifi-speakers') >= 0) {
        var el = $('.product-carousel-v2-2');
        $('.product-slide-v2-img-link', el).removeClass('product-slide-v2-img-link').addClass('acc-product-slide-v2-img-link');
        $('.product-slide-v2-btn-shop', el).removeClass('product-slide-v2-btn-shop').addClass('acc-product-slide-v2-btn-shop');
        $('.product-slide-v2-btn-explore', el).removeClass('product-slide-v2-btn-explore').addClass('acc-product-slide-v2-btn-explore');
      }
    }, 500);
  },
  initSwiper: (_this, slider_classname) => {
    var product_carousel_slider = new Swiper(`${slider_classname} .swiper`, product_carousel_v2.getSwiperConfig(_this, `${slider_classname} .swiper`));

    return product_carousel_slider;
  },
  getSwiperConfig: (_this, slider_classname) => {
    var view = _this.data('view') || 'api-html-carousel-v2';
    var type = _this.data('type') || 'slider';
    var center = _this.data('center');
    if (typeof center == 'undefined') {
      center = true;
    }

    var config = {
      direction: 'horizontal',
      loop: false,
      spaceBetween: 20,
      slidesPerView: 1,
      freeMode: true,
      centerInsufficientSlides: center,
      // centeredSlides: $(`${slider_classname} .swiper-slide`).length < 2,
      navigation: {
        nextEl: `${slider_classname} .swiper-button-next`,
        prevEl: `${slider_classname} .swiper-button-prev`,
      },
      pagination: {
        el: `${slider_classname} .swiper-pagination`,
        clickable: true,
      },
      scrollbar: {
        el: `${slider_classname} .swiper-scrollbar`,
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      breakpoints: {
        576: {
          spaceBetween: 20,
          slidesPerView: 2.5,
          // centeredSlides: $(`${slider_classname} .swiper-slide`).length < 3,
        },
        850: {
          spaceBetween: 20,
          slidesPerView: 3.5,
          // centeredSlides: $(`${slider_classname} .swiper-slide`).length < 4,
        },
      },
      on: {
        init: function(swiper) {
          var btn = $(`${slider_classname} .swiper-button-disabled`);
          btn.length == 2 ? btn.hide() : $(`${slider_classname} .swiper-button`).show();
        },
        resize: function(swiper) {
          var btn = $(`${slider_classname} .swiper-button-disabled`);

          btn.length == 2 ? btn.hide() : $(`${slider_classname} .swiper-button`).show();
        },
      },
    };

    if (view == 'api-html-carousel-v3') {
      config = {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 20,
        slidesPerView: 1,
        freeMode: true,
        centerInsufficientSlides: center,
        navigation: {
          nextEl: `${slider_classname} .swiper-button-next`,
          prevEl: `${slider_classname} .swiper-button-prev`,
        },
        pagination: {
          el: `${slider_classname} .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `${slider_classname} .swiper-scrollbar`,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          576: {
            spaceBetween: 20,
            slidesPerView: 2,
          },
          850: {
            spaceBetween: 20,
            slidesPerView: 3,
          },
        },
        on: {
          init: function(swiper) {
            var btn = $(`${slider_classname} .swiper-button-disabled`);
            btn.length == 2 ? btn.hide() : $(`${slider_classname} .swiper-button`).show();

            $(`${slider_classname} .swiper-button-prev`).css({
              left: `calc(calc(${swiper.el.clientWidth}px - 100vw) / 2)`
            });
            $(`${slider_classname} .swiper-button-next`).css({
              right: `calc(calc(${swiper.el.clientWidth}px - 100vw) / 2)`
            });
          },
          resize: function(swiper) {
            var btn = $(`${slider_classname} .swiper-button-disabled`);
            btn.length == 2 ? btn.hide() : $(`${slider_classname} .swiper-button`).show();

            $(`${slider_classname} .swiper-button-prev`).css({
              left: `calc(calc(${swiper.el.clientWidth}px - 100vw) / 2)`
            });
            $(`${slider_classname} .swiper-button-next`).css({
              right: `calc(calc(${swiper.el.clientWidth}px - 100vw) / 2)`
            });
          },
        },
      };
    } else if (view == 'api-html-carousel-v4' && type == 'slider') {
      config = {
        direction: 'horizontal',
        loop: false,
        spaceBetween: 8,
        slidesPerView: 2,
        slidesPerGroup: 2,
        freeMode: true,
        centerInsufficientSlides: center, 
        navigation: {
          nextEl: `${slider_classname} .swiper-button-next`,
          prevEl: `${slider_classname} .swiper-button-prev`,
        },
        pagination: {
          el: `${slider_classname} .swiper-pagination`,
          clickable: true,
        },
        scrollbar: {
          el: `${slider_classname} .swiper-scrollbar`,
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1024: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
        },
        on: {
          init: function(swiper) {
            var btn = $(`${slider_classname} .swiper-button-disabled`);
            btn.length == 2 ? btn.hide() : $(`${slider_classname} .swiper-button`).show();
  
            // $(`${slider_classname} .swiper-button-prev`).css({
            //   left: `calc(calc(${swiper.el.clientWidth}px - 100vw) / 2)`
            // });
            // $(`${slider_classname} .swiper-button-next`).css({
            //   right: `calc(calc(${swiper.el.clientWidth}px - 100vw) / 2)`
            // });
          },
          resize: function(swiper) {
            var btn = $(`${slider_classname} .swiper-button-disabled`);
            btn.length == 2 ? btn.hide() : $(`${slider_classname} .swiper-button`).show();
  
            // $(`${slider_classname} .swiper-button-prev`).css({
            //   left: `calc(calc(${swiper.el.clientWidth}px - 100vw) / 2)`
            // });
            // $(`${slider_classname} .swiper-button-next`).css({
            //   right: `calc(calc(${swiper.el.clientWidth}px - 100vw) / 2)`
            // });
          },
        },
      };
    }

    return config;
  },

  // v4
  v4: {
    init: (_this, classname) => {
      var type = _this.data('type') || 'grid';
  
      if (type == 'slider') {
        product_carousel_v2.v4.initSwiper(_this, `.${classname}`);
      } else if (type == 'grid') {
        product_carousel_v2.v4.initGrid(_this, `.${classname}`);
      } else {
        return false;
      }

      $(`.${classname} .product-swatch-elements`).each(function() {
        var el = $(this),
            swatch = $('.swatch-element', el)
            text = window.kef.product_carousel_texts.swatch_more.replace('{{ number }}', (swatch.length - 4));
        if (swatch.length > 4) {
          el.addClass('product-swatch-elements-mini').append(`<button type="button" class="product-swatch-elements-toggle">${text}</button>`)
        }
      });

      // variant change
      $(`.${classname}`).on('change', 'input[name*="swatch"]', function() {
        product_carousel_v2.updateVariant($(this));
      });
      $(`.${classname} input[name*="swatch"]`).trigger('change');
      // swatch
      $(`.${classname}`).on('click', '.product-swatch-elements-toggle', function() {
        $(this).parents('.product-swatch-elements').toggleClass('active');
      });
      // dropdown
      $(`.${classname}`).on('click', '.product-swatch-dropdown', function() {
        $(this).toggleClass('active');
      });
      $(`.${classname}`).on('change', '.product-swatch-dropdown input[name*="swatch"]', function() {
        $(this).parents('.swatch-element').addClass('active').siblings().removeClass('active');
        $('.product-swatch-dropdown').removeClass('active');
      });
      $(`body`).on('click', function(e) {
        if ($(e.target).closest('.product-swatch-dropdown').length == 0 && $('.product-swatch-dropdown.active').length > 0) {
          $(this).removeClass('active');
        }
      });
    },
    initGrid: (_this, classname) => {
      var grid_settings = _this.data('grid_settings') || '';
      var grid_settings_bs = ['', 'sm-', 'md-', 'lg-', 'xl-', 'xxl-'];
      var grid_settings_bs = ['', 'md-', 'lg-', 'xl-', 'xxl-'];
      var grid_col_classname = '';
      if (grid_settings.indexOf(',') >= 0) {
        grid_settings = grid_settings.split(',');
        $.each(grid_settings_bs, function(i, bs) {
          var grid_setting = grid_settings[i] || false;
          if (grid_setting === false) return false;
          
          grid_col_classname += ` col-${bs}${12/grid_setting}`;
        });
      } else if (grid_settings != '') {
        grid_col_classname = `col-${12/grid_settings}`;
      } else {
        grid_col_classname = `col`;
      }
  
      _this.attr('data-type', 'grid');
      $('.product-carousel-v2-container', _this).parent().wrap(`<div class="${grid_col_classname}" />`);
  
      _this.html(product_carousel_v2.html_grid.replace(product_carousel_v2.content_placeholder, _this.html()));
    },
    initSwiper: (_this, classname) => {
      _this.html(product_carousel_v2.html_swiper.replace(product_carousel_v2.content_placeholder, _this.html()));
  
      var ivt = setInterval(function() {
        if (typeof Swiper === 'function') {
          clearInterval(ivt);
          
          var product_carousel_slider = new Swiper(`${classname} .swiper`, product_carousel_v2.getSwiperConfig(_this, `${classname} .swiper`));
        }
      }, 500);
    },
  },
  
  updateVariant: (_this) => {
    var product = _this.parents(`.product-carousel-v2-container`);

    var opts = [];
    $('.product-carousel-v2-variants input:checked', product).each(function() {
      opts.push($(this).val());
    });

    var variant_option = $(`.product-variants-dropdown select option[data-variant_title="${opts.join(' / ')}"]`, product);
    $('.product-variants-dropdown select', product).val(variant_option.val());

    var product_img = $(`.product-carousel-v2-img img[data-variant_id="${variant_option.attr('value')}"]`, product);
    product_img.addClass('active')
      .siblings('img').removeClass('active');

    if ($(`.product-carousel-v2-price > s`, product).length == 1) {
      $(`.product-carousel-v2-price > s`, product).text(variant_option.attr('data-price_before_display'));
    }
    $(`.product-carousel-v2-price > span`, product).text(variant_option.attr('data-price_after_display'));
    
    var product_url = $(`a`, product).attr('href');
    if (product_url != '') {
      var url_obj = new URL(product_url, window.location.origin);
      url_obj.searchParams.set('variant', variant_option.val());
      $(`a`, product).attr('href', url_obj.toString());
    }
  }
}
product_carousel_v2.init();